import { IntegrationSyncSelectOption, SingleSelectInput } from "components";
import { observer } from "mobx-react";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import React, { FC, useCallback } from "react";
import { TReapitSyncLeadSourceExtendedData } from "types/reapit.type";
import { IntegrationEntitySyncStatusEnum } from "enums/integration-entity-sync-status.enum";
import { TSelectValue } from "types/select-input.type";

interface IProps {
  accountStore: UserAccountStore;
  record: TReapitSyncLeadSourceExtendedData;
  onChange: (syncPair: TReapitSyncLeadSourceExtendedData) => void;
}

export const ReapitLeadSourceSyncSelect: FC<IProps> = observer(
  ({ accountStore, record, onChange }) => {
    const options =
      accountStore.accountIntegrationsStore.accountIntegrationReapitStore
        .accountIntegrationReapitLeadSourcesStore.reapitLeadSourcesOptions;

    const handleChange = useCallback(
      (reapitId: TSelectValue<string>) => {
        onChange({
          reapitId: reapitId || null,
          leadSourceId: record.leadSourceId,
          leadSourceName: record.leadSourceName,
          syncStatus: IntegrationEntitySyncStatusEnum.NOT_SYNCED,
        });
      },
      [onChange, record]
    );

    return (
      <SingleSelectInput
        value={record.reapitId}
        clearable={true}
        options={options}
        onChange={handleChange}
        optionComponent={optionProps => (
          <IntegrationSyncSelectOption optionProps={optionProps} />
        )}
      />
    );
  }
);
